export default "__VITE_ASSET__Cssg2V2o__"